{
  "name": "sabt-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng cache clean && ng serve --configuration=local",
    "start-dev": "ng serve --configuration=dev",
    "start-preprod": "ng serve --configuration=preprod",
    "start-pro": "ng serve --configuration=production",
    "build:dev": "ng build --configuration=dev --output-path ./dist/sabt-frontend",
    "build:pre": "ng build --configuration=preprod --output-path ./dist/sabt-frontend",
    "build:pro": "ng build --configuration=production --output-path ./dist/sabt-frontend",
    "watch": "ng build --watch --configuration=dev",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.0",
    "@angular/cdk": "^19.2.6",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@auth0/auth0-angular": "^2.2.3",
    "@jsverse/transloco": "^7.5.1",
    "@jsverse/transloco-locale": "^7.0.1",
    "@ngrx/operators": "^19.0.0",
    "@ngrx/signals": "^19.0.0",
    "@types/leaflet": "^1.9.20",
    "auth0-angular": "github:auth0/auth0-angular",
    "chart.js": "^4.4.8",
    "chartjs-adapter-luxon": "^1.3.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "date-fns": "^4.4.0",
    "leaflet": "^1.9.4",
    "lodash": "^4.18.1",
    "luxon": "^3.6.1",
    "ng-zorro-antd": "^19.1.0",
    "proj4": "^2.19.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.0",
    "@angular/cli": "^19.1.0",
    "@angular/compiler-cli": "^19.1.0",
    "@faker-js/faker": "^9.5.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.24",
    "@types/proj4": "^2.5.6",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.1",
    "prettier": "^3.5.0",
    "prettier-plugin-tailwindcss": "^0.6.11",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.7.2"
  }
}
